import React from 'react';
import clsx from 'clsx';
import styles from './mobile-pagination.module.scss';

interface PaginationProps {
  currentPage: number;
  pageCount: number;
  showScrollTop: boolean;
  handleNext: () => void;
  handlePrevious: () => void;
}

const MobilePagination = ({ currentPage, pageCount, handleNext, handlePrevious, showScrollTop }: PaginationProps) => {
  return (
    <>
      <div className={styles.pagination__container}>
        <button
          className={styles.pagination__arrowButton}
          aria-label="Previous Page"
          onClick={handlePrevious}
          disabled={currentPage === 1}
        >
          <div className={clsx(styles.pagination__arrowIcon, styles.pagination__prevIcon)} />
        </button>
        <div className={styles.pagination__countContainer}>
          <span>
            {currentPage} / {pageCount}
          </span>
        </div>
        <button
          aria-label="Next Page"
          className={styles.pagination__arrowButton}
          onClick={handleNext}
          disabled={currentPage === pageCount}
        >
          <div className={clsx(styles.pagination__arrowIcon, styles.pagination__nextIcon)} />
        </button>
        {showScrollTop && (
          <button
            aria-label="Scroll to top"
            className={styles.pagination__scrollTopButton}
            onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
          >
            <div className={clsx(styles.pagination__arrowIcon, styles.pagination__upIcon)} />
          </button>
        )}
      </div>
    </>
  );
};

export default MobilePagination;
